export default "__VITE_ASSET__CVuHaA8T__"